var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import _ from 'lodash';
import { ApiGetComments } from '@/infrastructure/api-functions/api-get-comments';
import { DateFormatter } from '@/infrastructure/utils/date-formatter.interface';
let ApiPaginatedComments = class ApiPaginatedComments {
    constructor(_apiGetComments, _dateFormatter) {
        this._apiGetComments = _apiGetComments;
        this._dateFormatter = _dateFormatter;
    }
    async query(data) {
        const req = {
            rows: data.pageSize,
            page: data.page,
            content: data.keyword,
            sort: data.sort,
            comment_type: data.type,
            space_id: data.space,
            visible_scope: data.scope,
        };
        const resp = await this._apiGetComments.getComments(req);
        const limit = resp.row;
        const totalPage = Math.ceil(resp.total / limit);
        const result = {
            page: resp.page,
            pageSize: limit,
            totalPage,
            total: resp.total,
            totalWithoutFilter: resp.total,
            data: _.map(resp.comment_console_rep_dto_list || [], this._formatCommentEntity.bind(this)),
        };
        return result;
    }
    _formatCommentEntity(data) {
        const entity = {
            dataId: data.data_id,
            dataType: data.data_type,
            commentId: data.comment_id,
            commentType: data.comment_type,
            commentContent: data.content,
            commentScope: data.visible_scope,
            title: data.title,
            pn: data.pn,
            spaceId: data.space_id,
            spaceName: data.space_name,
            folderId: data.folder_id,
            lastUpdateTime: this._dateFormatter.format(_.toNumber(data.update_time)),
        };
        return entity;
    }
};
ApiPaginatedComments = __decorate([
    injectable(),
    __param(0, inject(ApiGetComments)),
    __param(1, inject(DateFormatter)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiGetComments !== "undefined" && ApiGetComments) === "function" ? _a : Object, typeof (_b = typeof DateFormatter !== "undefined" && DateFormatter) === "function" ? _b : Object])
], ApiPaginatedComments);
export { ApiPaginatedComments };
